import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Controller } from "react-hook-form";
import { resetStatus } from "../redux/storesSagas";
import { useAdd } from "../hooks/useAdd";
import { useError } from "../../../../hooks/useError";
import { MainModal } from "../../../../components/modal/MainModal";
import { Input } from "../../../../components/form/Input/Input";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";
import ReactDatePicker from "../../../../components/reactDatePicker/reactDatePicker";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import Dropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { ErrorList } from "../../../../components/ErrorList";
import { showToast } from "../../../../utils/showToast";

export const Add = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const { form: { register, control, formState: { errors, dirtyFields } = {} } = {}, submit } =
    useAdd();

  const { chains, organizations } = useSelector((state) => state.stores.commonSettings);

  const close = () => {
    dispatch(resetStatus());
    onClose();
  };
  const primaryButtonDisabled =
    (dirtyFields && Object.keys(dirtyFields).length === 0) || status == "pending";

  const { errors: serverErrors, status } = useError({
    cb: () => {
      showToast("Store was successfully updated");
      close();
    },
    sliceKey: "stores"
  });

  return (
    <>
      <MainModal
        isOpen={isOpen}
        onClose={close}
        parentSelector=".stores"
        headerText="Add Store"
        headerCloseHandler={close}
        primaryButtonText="Save"
        primaryButtonDisabled={primaryButtonDisabled}
        primaryBtnHandler={submit}
        containerClassName="add"
        secondaryBtnText="Cancel"
        secondaryBtnHandler={close}
        height="auto"
        width={900}
      >
        <div className="stores__info">
          <div className="stores__section">
            <Input
              label="Store ID"
              placeholder="Enter Store ID"
              htmlFor="remote_uid"
              customProps={register("remote_uid")}
            />
            <div className="stores__dropdown">
              <p>Organization</p>
              <Controller
                control={control}
                name="organization_id"
                render={({ field: { onChange, value } }) => {
                  return (
                    <Dropdown
                      height={275}
                      numberDisplayed={0}
                      haveOnSelectChange
                      options={organizations}
                      selectedFilters={value}
                      onSelectChange={(data) => onChange(data)}
                    />
                  );
                }}
              />
            </div>
            <div className="switch">
              <p className="switch__title">Inactive</p>
              <Controller
                control={control}
                name="inactive"
                render={({ field: { onChange, value } }) => {
                  return (
                    <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                      <ToggleableButton
                        isRadio
                        title="inactive"
                        isActive={value}
                        onClick={(isActive) => onChange(isActive)}
                      />
                    </div>
                  );
                }}
              />
            </div>
            <div className="switch">
              <p className="switch__title">Force Active</p>
              <Controller
                control={control}
                name="force_active"
                render={({ field: { onChange, value } }) => {
                  return (
                    <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                      <ToggleableButton
                        isRadio
                        title="force active"
                        isActive={value}
                        onClick={(isActive) => onChange(isActive)}
                      />
                    </div>
                  );
                }}
              />
            </div>
          </div>
          <div className="stores__section">
            <Input
              label="Name"
              placeholder="Enter Store Name"
              htmlFor="name"
              customProps={register("name")}
            />
            <div className="stores__dropdown">
              <p>Chain</p>
              <Controller
                control={control}
                name="clubready_chain_id"
                render={({ field: { onChange, value } }) => {
                  return (
                    <Dropdown
                      height={275}
                      numberDisplayed={0}
                      haveOnSelectChange
                      options={chains}
                      selectedFilters={value}
                      onSelectChange={(data) => onChange(data)}
                    />
                  );
                }}
              />
            </div>
            <div className="switch">
              <p className="switch__title">Without Chain</p>
              <Controller
                control={control}
                name="without_chain"
                render={({ field: { onChange, value } }) => {
                  return (
                    <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                      <ToggleableButton
                        isRadio
                        title="Without Chain"
                        isActive={value}
                        onClick={(isActive) => onChange(isActive)}
                      />
                    </div>
                  );
                }}
              />
            </div>
            <div className="switch">
              <p className="switch__title">Opened</p>
              <Controller
                control={control}
                name="opened"
                render={({ field: { onChange, value } }) => {
                  return (
                    <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                      <ToggleableButton
                        isRadio
                        title="Opened"
                        isActive={value}
                        onClick={(isActive) => onChange(isActive)}
                      />
                    </div>
                  );
                }}
              />
            </div>
          </div>
          <div className="stores__section">
            <div className="admin-users__date">
              <p>First Calculation Date</p>
              <Controller
                control={control}
                name="first_calculation_date"
                render={({ field: { onChange, onBlur, value } }) => {
                  return (
                    <ReactDatePicker
                      showDefaultInputIcon={false}
                      showClearDate
                      onBlur={onBlur}
                      startDate={value}
                      allowAllDays
                      updateDates={(data) => onChange(data)}
                    />
                  );
                }}
              />
            </div>
            <div className="admin-users__date">
              <p>First revenue calc date</p>
              <Controller
                control={control}
                name="first_revenue_calculation_date"
                render={({ field: { onChange, onBlur, value } }) => {
                  return (
                    <ReactDatePicker
                      showDefaultInputIcon={false}
                      showClearDate
                      onBlur={onBlur}
                      startDate={value}
                      allowAllDays
                      updateDates={(data) => onChange(data)}
                    />
                  );
                }}
              />
            </div>
          </div>
        </div>

        {status === "pending" && <LoadingAnimation uiLoader />}
        <ErrorList errors={{ ...errors, ...serverErrors }} />
      </MainModal>
    </>
  );
};
